import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "./AuthProvider";
import CreateGame from './CreateGame';
import FactoryImage from './factory.png';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { BuildingsFill } from 'react-bootstrap-icons';
import { useNavigate } from "react-router-dom";
import { ADMIN } from './Roles';
import { useTranslation } from 'react-i18next';
import { GAME_STATUSES, GameStatus } from './GameStatus';

const GameCard = ({ game }) => {
    return (
        <Card style={{ position: 'relative' }}>
            <div
                style={{
                    backgroundImage: `url(${FactoryImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 0,
                }}
            />
            <div
                style={{
                    backgroundColor: `${GAME_STATUSES[game.status].bgColor}`,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1,
                }}
            />
            <Card.Body className="text-light d-flex justify-content-center align-items-center" style={{ position: 'relative', zIndex: 2 }}>
                <Card.Title className="d-flex align-items-center fs-4">
                    <BuildingsFill className="me-2" />
                    {game.name}
                </Card.Title>
            </Card.Body>
        </Card>
    );
};

const GamesList = () => {
    const auth = useAuth();
    const [games, setGames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [creating, setCreating] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { i18n } = useTranslation();

    useEffect(() => {
         axios.get('/api/games', {
           headers: {
             Authorization: `Bearer ${auth.token}`,
           },
         })
           .then(response => {
             setGames(response.data);
             setLoading(false);
           })
           .catch(error => {
             console.log(error);
             setError(error);
             setLoading(false);
             if (error.status === 401) {
               auth.logOut();
             }
           });
       }, [auth]);

       if (loading) return <p>{t('common.loading')}</p>;
       if (error) return <p>{t('games.loading-error')}: {error.message}</p>;

       return (
           <div>
                 {games.length === 0 && <div>{t('games.no-games')}</div>}
                 <Row className="g-3">
                   {games.map((game) => (
                     <Col key={game.id} xs={12} sm={6} md={4} lg={2}>
                       <Card style={{ width: '100%' }} className="text-center">
                        <GameCard game={game} />
                        <Card.Body>
                          <GameStatus status={game?.status} t={t} />
                          <Card.Text>
                              {game?.status === "ROUND_ACTIVE" && <span>{t('games.round')} {game.round} / {game.rounds}</span>}
                              {game?.status === "INITIALIZED" && <span>{t('games.rounds')} {game.rounds}</span>}
                          </Card.Text>
                          <Card.Text>
                              {t('games.created')}: {new Date(game.createdAt).toLocaleDateString(i18n.language)}
                          </Card.Text>
                         </Card.Body>
                         <Card.Body>
                           <Button variant="secondary" onClick={() => navigate(`${game.id}`)}>{t('games.details')}</Button>
                        </Card.Body>
                       </Card>
                     </Col>
                   ))}
                 </Row>
                {auth.roles.includes(ADMIN) && <div className="mt-4">
                  <Button variant="primary" onClick={() => setCreating(true)} disabled={creating}>
                    {t('games.create')}
                  </Button>
                  {creating && <CreateGame show={creating} onClose={() => setCreating(false)} setCreating={setCreating} />}
                </div>}
               </div>
       );
};

export default GamesList;